import { ReactNode } from "react";

export interface refundReasonObj{
  key:RefundReasons,
  title:string,
  label?:string,
  totalPrice?:string,
  hasInfo?:boolean,
  hide:boolean
}
export interface refundDialogButton{
  label:string,
  color:string,
  Icon?:ReactNode,
  labelColor?:string
}

export interface RefundTitles {
  ConfirmButtonLabel:string , 
  ConfirmButtonColor:string ,
  Title:string ,
  DialogTitle:string ,
  InfoCardTitle:string ,
  InfoCardContent:string,
  SpecificItemsDialogTitle:string,
  SpecificItemsDialogLabel:string,
}

export interface selectedQuantity{
  id:string;
  quantity:number
}
export enum RefundReasons {
  STOCK = "STOCK",
  OTHER = "OTHER",
  DISSATISFACTION = "DISSATISFACTION",
  SPECIALITEMS = "SPECIALITEMS",
  REFUNDENTIRE = "REFUNDENTIRE"
}

export enum RefundActionType {
  DECLINE = "DECLINE",
  REFUND = "REFUND"
}
export enum RefundType {
  FULL = "full",
  ITEMISED = "itemised"
}